import type { LucideProps } from "lucide-react";
import type { ComponentType, ReactNode } from "react";

/** A point in the conversation the reader should know about, drawn across it: a hairline on
    each side of a quiet label and its icon, or `lead` in its place (an agent's avatar), (DESIGN.md
    §5, "Transcript dividers"). `label` makes it a separator for screen readers; one holding a
    control (a branch's link, the earlier-messages button) has none. */
export default function TranscriptDivider({ icon: Icon, lead, children, label, title }: {
  icon?: ComponentType<LucideProps>;
  lead?: ReactNode;
  children: ReactNode;
  label?: string;
  title?: string;
}) {
  return (
    <div role={label ? "separator" : undefined} aria-label={label} title={title} className="flex items-center gap-3 py-1 fade-in">
      <div className="flex-1 h-px bg-[var(--hairline)]" />
      <span className="flex items-center gap-1.5 text-[11.5px] text-[var(--text-tertiary)] tracking-[-0.005em] shrink-0">
        {lead ?? (Icon && <Icon className="w-3 h-3" strokeWidth={1.75} />)}
        {children}
      </span>
      <div className="flex-1 h-px bg-[var(--hairline)]" />
    </div>
  );
}
